
import styled from 'styled-components';
import { Form as AntdForm } from 'antd';

const Form = styled(AntdForm)`
  width: 100%;

  & label {
    color: white;
    font-weight: 400;
    font-size: 25px;
    margin-bottom: 0.35em;
  }
`;

export default Form;
